var _g, _path, _path2, _g2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerPtpBroken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 45,
    viewBox: "0 0 68 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_857_933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6973 19.144C31.9206 16.8832 33.7153 15.098 35.9772 14.8866L58.7301 12.7609C58.9536 12.74 59.1783 12.735 59.4025 12.7459L61.101 12.8288C61.2665 12.8368 61.4304 12.8662 61.5885 12.9161C62.3923 13.1699 62.9389 13.9156 62.9389 14.7585V30.8437C62.9389 33.5639 60.6562 35.7271 57.9399 35.581L56.2011 35.4875V39.3644L54.4434 38.9739L51.9046 35.2564L33.0454 34.3134C32.1199 34.2671 31.2828 33.7497 30.8275 32.9426C30.5546 32.4589 30.4375 31.9028 30.4921 31.35L31.6973 19.144Z",
    fill: "#EBEEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2118 35.2878L56.0011 35.2764V35.4875V39.1151L54.564 38.7958L52.0697 35.1436L52.0137 35.0616L51.9145 35.0566L33.0554 34.1136C32.1984 34.0708 31.4233 33.5917 31.0017 32.8444C30.749 32.3964 30.6406 31.8815 30.6911 31.3697L31.8964 19.1637C32.1102 16.9982 33.8292 15.2882 35.9958 15.0858L58.7487 12.96C58.9628 12.94 59.178 12.9352 59.3928 12.9457L61.0912 13.0285C61.2397 13.0358 61.3865 13.0621 61.5283 13.1068C62.2489 13.3343 62.7389 14.0028 62.7389 14.7585V30.8437C62.7389 33.4492 60.5525 35.5212 57.9507 35.3813L56.2118 35.2878Z",
    stroke: "#BB7065",
    strokeOpacity: 0.4,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3037 19.2438C30.3037 16.7573 32.2236 14.6926 34.7036 14.5122L56.0723 12.9572C58.8208 12.7572 61.1608 14.9331 61.1608 17.6889V30.4254C61.1608 33.1457 58.8782 35.3088 56.1618 35.1627L54.423 35.0692V38.9462L50.1265 34.8381L34.7931 34.0134C32.2756 33.878 30.3037 31.7972 30.3037 29.2761V19.2438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4338 34.8695L54.223 34.8582V35.0692V38.4783L50.2647 34.6936L50.2111 34.6424L50.1372 34.6384L34.8038 33.8137C32.3925 33.684 30.5037 31.6909 30.5037 29.2761V19.2438C30.5037 16.8621 32.3426 14.8845 34.7181 14.7116L56.0868 13.1567C58.7194 12.9651 60.9608 15.0493 60.9608 17.6889V30.4254C60.9608 33.031 58.7744 35.103 56.1726 34.963L54.4338 34.8695Z",
    stroke: "#BB7065",
    strokeOpacity: 0.4,
    strokeWidth: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9435 27.1036L41.7583 27.2539C41.5344 27.2539 41.3511 27.0566 41.3511 26.8134L41.3496 18.8266C41.3496 18.5835 41.5321 18.3862 41.7569 18.3862L43.9435 18.6044C44.1683 18.6044 44.3508 18.8018 44.3508 19.0448V26.6632C44.3508 26.9064 44.1675 27.1036 43.9435 27.1036Z",
    fill: "#BB7065"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4974 26.5553C52.4372 26.5664 49.5615 26.7376 49.5615 26.7376L49.9555 27.9079C50.2273 28.7162 50.0513 29.9504 49.297 30.3891C49.0514 30.532 48.7082 30.6038 48.4316 30.5279C48.2729 30.4845 48.1334 30.3701 48.0503 30.2169C47.9548 30.0406 47.9646 29.8349 47.9306 29.6395C47.8443 29.1439 47.6292 28.6726 47.2961 28.3189C46.7153 27.7022 44.9111 26.7376 44.9111 26.7376V19.1909L51.1457 19.4066C51.987 19.406 52.5383 20.4289 52.1234 21.2278C52.6179 21.5727 52.7871 22.2992 52.4974 22.8569C52.9921 23.2018 53.1612 23.9283 52.8715 24.4861C53.6165 25.114 53.4946 26.3716 52.4974 26.5553Z",
    fill: "#BB7065"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_857_933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 7.65385C3 4.91817 5.3075 2.74938 8.03794 2.91878L29.5726 4.25476C32.2515 4.42095 34.2591 6.77445 34.001 9.44601L32.8691 21.1631C32.6342 23.5952 30.5904 25.4511 28.1469 25.4511H14.2056L11.0875 30.9115L9.04129 31.6017V25.4511H7.74418C5.12404 25.4511 3 23.3271 3 20.7069V7.65385Z",
    fill: "#BB7065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.76062C3 5.04016 3.58464 2.30659 7.48225 2.20898L30.5756 3.67341C32.6307 3.8009 34.4732 6.16655 34.4732 8.22957L35.6997 21.2118C35.7264 21.4946 35.7328 21.7819 35.6887 22.0626C35.2139 25.0874 32.6353 25.4511 30.5756 25.4511H14.2056L11.0875 30.9115L9.04129 31.6017V25.4511H6.89761C4.74502 25.4511 3 23.7027 3 21.546V6.76062Z",
    fill: "#BB7065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1504 24.7282L16.1205 24.7639L11.1308 30.6999V24.8282V24.7282H11.0308H9.73148C7.16657 24.7282 5.0873 22.6489 5.0873 20.084V7.04729C5.0873 4.36956 7.3457 2.24662 10.0183 2.41196C10.0184 2.41197 10.0186 2.41198 10.0187 2.41199L32.0151 3.77512C32.0156 3.77515 32.0161 3.77519 32.0166 3.77522C34.4645 3.92771 36.372 5.95755 36.372 8.41041V20.084C36.372 22.6489 34.2927 24.7282 31.7278 24.7282H16.197H16.1504ZM5.16992 21.7184C5.65785 23.0801 6.7382 24.1597 8.10034 24.6467C6.6349 24.3382 5.48042 23.1843 5.16992 21.7184ZM8.45299 2.37315C6.90927 2.79501 5.66374 3.96512 5.14632 5.47938C5.43941 3.83164 6.79106 2.56165 8.45299 2.37315ZM36.2581 6.69206C35.8035 5.49456 34.8872 4.52039 33.7196 3.99354C34.9732 4.38991 35.9383 5.41595 36.2581 6.69206ZM33.359 24.6467C34.7211 24.1597 35.8014 23.0801 36.2894 21.7184C35.9789 23.1843 34.8244 24.3382 33.359 24.6467Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8457 15.9754C25.8457 14.4958 24.5827 13.6776 23.0588 13.3077V10.8891C23.7453 10.9745 24.4591 11.2163 25.1593 11.6289L25.8457 10.0724C24.9844 9.29125 23.6109 8.73468 23.0588 8.73468V7.46045H21.686V8.55747C19.5169 8.81355 18.2677 9.79215 18.2676 11.6289C18.2676 14.4116 20.1621 14.6592 21.686 15.0433V17.1247C20.6976 17.0251 19.6032 16.7363 18.9168 16.2099L18.2676 18.3076C19.0226 18.9194 20.3269 19.3901 21.686 19.4754V20.8336H23.0588V19.3709C25.2142 19.1006 25.8457 17.455 25.8457 15.9754ZM20.6701 11.9846C20.6701 11.5151 20.9584 11.1025 21.686 10.9318V12.952C21.082 12.7528 20.6701 12.4825 20.6701 11.9846ZM23.0588 17.3623V15.399C23.6492 15.6124 24.0473 15.8827 24.0473 16.3807C24.0473 16.8359 23.7453 17.2058 23.0588 17.3623Z",
    fill: "#BB7065"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_857_933",
    x: 25.0851,
    y: 8.47047,
    width: 42.1231,
    height: 36.1124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.474418,
    dy: 0.474418
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.37209
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_857_933"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_857_933",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_857_933",
    x: 0.627911,
    y: 0.785731,
    width: 38.2159,
    height: 34.1368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.948835
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18604
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_857_933"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_857_933",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPtpBroken);
export default __webpack_public_path__ + "static/media/customer_ptp_broken.fcb906178f4ca270b5a0442b88530d65.svg";
export { ForwardRef as ReactComponent };